import { useQuery } from '@apollo/client';

import WorkSummaryTray from '@atom/components/mapPortal/workSummary/WorkSummaryTray';
import { GET_WORK_ORDER } from '@atom/graph/work';
import { SearchParamType, useNavigation } from '@atom/hooks/useNavigation';
import { WorkOrderDetailType } from '@atom/types/work';

const WorkSummaryWrapper = () => {
  const [{ id }, { updateSearchParams }] = useNavigation({
    id: SearchParamType.STRING,
    view: SearchParamType.STRING,
  });

  const { data, loading } = useQuery<
    { workOrder: WorkOrderDetailType },
    { id: string }
  >(GET_WORK_ORDER, {
    variables: {
      id,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
  });

  const onCancel = () => {
    updateSearchParams({ view: 'list', id: null });
  };

  return (
    <WorkSummaryTray
      workOrderDetail={data?.workOrder}
      loading={loading}
      onCancel={onCancel}
    />
  );
};

export default WorkSummaryWrapper;
